import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const INVITE_TOKEN_KEY = 'yt8_pending_invite';

function InviteLanding({ currentUser, currentUserProfile }) {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const fn = httpsCallable(functions, 'getInvite');
        const { data } = await fn({ token });
        if (!data || data.status !== 'pending' || data.expired) { setInvalid(true); setLoading(false); return; }
        setInvite(data);
      } catch {
        setInvalid(true);
      }
      setLoading(false);
    };
    load();
  }, [token]);

  const handleAccept = () => {
    // Store token so we can claim it after signup
    localStorage.setItem(INVITE_TOKEN_KEY, token);

    if (currentUser && currentUserProfile) {
      // Already signed in and has a profile — claim immediately
      navigate('/');
    } else if (currentUser) {
      // Signed in but no profile yet
      navigate('/create-profile');
    } else {
      // Not signed in
      navigate('/');
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
        <span className="spinner" style={{ width: 32, height: 32 }} />
      </div>
    );
  }

  if (invalid) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 24 }}>
        <div style={{ textAlign: 'center', maxWidth: 400 }}>
            <h2 style={{ margin: '0 0 8px', fontSize: 22 }}>Invite not found</h2>
          <p style={{ color: 'var(--muted)', marginBottom: 24 }}>This invite link has already been used or has expired.</p>
          <Link to="/" className="btn btn-primary">Go to Your Top 8</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 24 }}>
      <div style={{
        width: '100%', maxWidth: 420, textAlign: 'center',
        background: 'var(--card)', border: '1px solid var(--border)',
        borderRadius: 'var(--radius)', padding: 36,
        boxShadow: 'var(--shadow)',
      }}>
        {/* Inviter avatar */}
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: 'var(--card-2)', border: '2px solid var(--accent)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px', overflow: 'hidden', fontSize: 28, fontWeight: 800, color: 'var(--accent)',
        }}>
          {invite.fromPhotoURL
            ? <img src={invite.fromPhotoURL} alt={invite.fromDisplayName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : invite.fromDisplayName?.[0]?.toUpperCase()
          }
        </div>

        <div style={{
          display: 'inline-block',
          fontSize: 11, fontWeight: 700, letterSpacing: 1,
          textTransform: 'uppercase', color: 'var(--accent)',
          marginBottom: 10,
        }}>
          You've been added to a Top 8
        </div>

        <h2 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: 800 }}>
          {invite.fromDisplayName} added you!
        </h2>
        <p style={{ color: 'var(--muted)', fontSize: 15, margin: '0 0 28px', lineHeight: 1.6 }}>
          <strong style={{ color: 'var(--text)' }}>{invite.fromDisplayName}</strong> added{' '}
          <strong style={{ color: 'var(--text)' }}>{invite.tileName}</strong> to their Top 8 on Your Top 8.
          Join to get notified when your rank changes, and build your own Top 8.
        </p>

        <button className="btn btn-primary btn-block" onClick={handleAccept} style={{ fontSize: 15, padding: '13px 24px' }}>
          Join Your Top 8
        </button>

        <p style={{ color: 'var(--muted)', fontSize: 12, marginTop: 16 }}>
          Free forever. No spam.
        </p>
      </div>
    </div>
  );
}

export { INVITE_TOKEN_KEY };
export default InviteLanding;
